import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

interface ResourceSaveFooterProps {
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  className?: string;
}

/** Explicit commit controls shared by lightweight resource editors. */
export const ResourceSaveFooter: FC<ResourceSaveFooterProps> = (props) => {
  const { onCancel, onSave, isSaving, isSaveDisabled, className } = props;

  return (
    <div
      className={twMerge(
        "flex shrink-0 items-center justify-end gap-2 border-t border-border-light bg-card px-4 py-3 sm:px-6",
        className,
      )}
    >
      <Button
        variant={ButtonVariant.Secondary}
        size={Size.SMALL}
        onClick={onCancel}
        isDisabled={isSaving}
      >
        Cancel
      </Button>
      <Button
        variant={ButtonVariant.Primary}
        size={Size.SMALL}
        onClick={onSave}
        isLoading={isSaving}
        isDisabled={isSaving || isSaveDisabled}
      >
        Save
      </Button>
    </div>
  );
};
